import { Box, Container, Typography, Grid } from '@mui/material'
import DesignServicesIcon from '@mui/icons-material/DesignServices'
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import TouchAppIcon from '@mui/icons-material/TouchApp'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import { SectionHeading, Icon } from '@/components/common'
import { problemContent } from '@/data/content'

/**
 * Pain point icon mapping
 */
const painPointIcons = {
  'Outdated Design': DesignServicesIcon,
  'Poor Mobile Experience': PhonelinkEraseIcon,
  'Not Ranking in Search': TrendingDownIcon,
  "Visitors Don't Convert": TouchAppIcon,
  'Weak Online Credibility': VerifiedUserIcon,
}

/**
 * Problem Section Component
 * Highlights pain points plumbing businesses face
 */
export const ProblemSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'grey.100',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" subtitle={problemContent.subheading}>
          {problemContent.heading}
        </SectionHeading>

        <Grid container spacing={{ xs: 3, md: 4 }} sx={{ mt: 2 }}>
          {problemContent.painPoints.map((painPoint, index) => {
            const IconComponent = painPointIcons[painPoint.title as keyof typeof painPointIcons]

            return (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    p: 3,
                    bgcolor: 'white',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'grey.200',
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      flexShrink: 0,
                    }}
                  >
                    <Icon
                      icon={IconComponent}
                      size="large"
                      sx={{
                        color: 'error.main',
                        fontSize: '2.5rem',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                      }}
                    >
                      {painPoint.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        lineHeight: 1.6,
                      }}
                    >
                      {painPoint.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )
          })}
        </Grid>
      </Container>
    </Box>
  )
}
